export let projectTypeTag = {
  bindings: {
    project: '<'
  },
  template: `
    <div class="text-xxs projectTypeTag font-bold text-block" ng-class="proVM.tagClass(proVM.project)">
      <p class="text-block no-margin">{{ proVM.project.activityTypeName }}</p>
    </div>`,
  controllerAs: 'proVM',
  controller: ['Validations', 'Ramda',
  function projectTypeCtrl (Validations, Ramda) {
    const R = Ramda

    const isBlue = R.curry((lib, project) => {
      return lib.isCrossProject(project)
    })

    const isPurple = R.curry((lib, project) => {
      return lib.isInternalProject(project)
    })

    const tagClass = R.curry((lib, project) => {
      switch (true) {
        case isBlue(lib, project):
          return 'azul'
        case isPurple(lib, project):
          return 'morado'
      }
    })

    this.tagClass = tagClass(Validations)
  }
]}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/projectFormulation/list/proposals/project-type-tag.js